import client from './client';

export interface ContentData {
  title: string;
  content: string;
}

export interface ConfirmJusticeResponse {
  success: boolean;
  isWhitelisted: boolean;
}

export const getContent = async (type: 'lingshanhui' | 'migongdao'): Promise<ContentData> => {
  const response = await client.get(`/content/${type}`);
  return response.data.data;
};

export const confirmJustice = async (): Promise<ConfirmJusticeResponse> => {
  const response = await client.post('/migongdao/agree');
  return response.data.data;
};
